import React, { useState } from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import g2TravelApi from '../../services/g2TravelApi';
import './Duffel.css';

const getDefaultCheckIn = () => {
  const d = new Date();
  d.setDate(d.getDate() + 7);
  return d.toISOString().split('T')[0];
};

const getDefaultCheckOut = () => {
  const d = new Date();
  d.setDate(d.getDate() + 8);
  return d.toISOString().split('T')[0];
};

const Duffel = ({ onGoHome, onNavigate }) => {
  const [form, setForm] = useState({
    checkInDate: getDefaultCheckIn(),
    checkOutDate: getDefaultCheckOut(),
    adults: 2,
    children: 0,
    rooms: 1,
    latitude: 25.2048,
    longitude: 55.2708,
    radiusKm: 25,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [results, setResults] = useState([]);
  const [rawCount, setRawCount] = useState(0);

  const updateField = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setResults([]);
    setRawCount(0);

    try {
      const response = await g2TravelApi.duffelSearch({
        checkInDate: form.checkInDate,
        checkOutDate: form.checkOutDate,
        adults: Number(form.adults),
        children: Number(form.children),
        rooms: Number(form.rooms),
        latitude: Number(form.latitude),
        longitude: Number(form.longitude),
        radiusKm: Number(form.radiusKm),
      });
      const hotels = Array.isArray(response?.hotels) ? response.hotels : [];
      setResults(hotels);
      setRawCount(Number(response?.count || hotels.length));
    } catch (err) {
      setError(err?.message || 'Duffel search failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="duffel-page">
      <Header onLogoClick={onGoHome} onNavigate={onNavigate} />
      <main className="duffel-main">
        <div className="duffel-container">
          <h1>Duffel Hotels Test</h1>
          <p className="duffel-subtitle">Search only Duffel stays from your backend integration.</p>

          <form className="duffel-form" onSubmit={handleSubmit}>
            <label>
              Check-in
              <input type="date" value={form.checkInDate} onChange={(e) => updateField('checkInDate', e.target.value)} required />
            </label>
            <label>
              Check-out
              <input type="date" value={form.checkOutDate} onChange={(e) => updateField('checkOutDate', e.target.value)} required />
            </label>
            <label>
              Adults
              <input type="number" min="1" value={form.adults} onChange={(e) => updateField('adults', e.target.value)} required />
            </label>
            <label>
              Children
              <input type="number" min="0" value={form.children} onChange={(e) => updateField('children', e.target.value)} />
            </label>
            <label>
              Rooms
              <input type="number" min="1" value={form.rooms} onChange={(e) => updateField('rooms', e.target.value)} required />
            </label>
            <label>
              Latitude
              <input type="number" step="any" value={form.latitude} onChange={(e) => updateField('latitude', e.target.value)} required />
            </label>
            <label>
              Longitude
              <input type="number" step="any" value={form.longitude} onChange={(e) => updateField('longitude', e.target.value)} required />
            </label>
            <label>
              Radius (km)
              <input type="number" min="1" value={form.radiusKm} onChange={(e) => updateField('radiusKm', e.target.value)} />
            </label>
            <button type="submit" disabled={loading}>
              {loading ? 'Searching...' : 'Search Duffel'}
            </button>
          </form>

          {error ? <div className="duffel-error">{error}</div> : null}

          <div className="duffel-results-head">
            <strong>Results:</strong> {results.length} shown ({rawCount} from API)
          </div>

          <div className="duffel-results">
            {results.map((hotel) => (
              <article key={hotel.id} className="duffel-card">
                <h3>{hotel.name || 'Duffel Hotel'}</h3>
                <p>
                  {hotel.cityName || hotel.city || 'Unknown city'}
                  {hotel.countryName ? `, ${hotel.countryName}` : ''}
                </p>
                <p>{hotel.address1 || 'No address'}</p>
                <p>
                  {hotel.minPrice ? `${hotel.minPrice} ${hotel.minPriceCurrency || ''}` : 'Price unavailable'}
                </p>
              </article>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Duffel;
